export const ASSETS = {
    LOGO: "logo_new.png",
    PROFILE: "him_profile.png",
};
